var exports = {
  "kL": "xa15a2ab7--ba4a92--container",
  "vK": "xa15a2ab7--ba4a92--banner",
  "Qs": "xa15a2ab7--ba4a92--content",
  "Qq": "xa15a2ab7--ba4a92--text",
  "Pf": "xa15a2ab7--ba4a92--label",
  "Lr": "xa15a2ab7--ba4a92--house-1",
  "So": "xa15a2ab7--ba4a92--house-2",
  "w9": "xa15a2ab7--ba4a92--coin",
};

module.exports = exports;
